export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(auth)/about": [12,[4]],
		"/(app)/assets": [6,[2]],
		"/(app)/assets/new": [10,[2]],
		"/(app)/assets/[id]": [7,[2,3]],
		"/(app)/assets/[id]/renewals/new": [9,[2,3]],
		"/(app)/assets/[id]/renewals/[renewalId]/edit": [8,[2,3]],
		"/(auth)/forgot-password": [13,[4]],
		"/(auth)/login": [14,[4]],
		"/(app)/settings": [11,[2]],
		"/(auth)/signup": [15,[4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';